<app-service-order-invoice-form [editMode]="editMode" [invoiceNumber]="invoiceNumber"
                                #data></app-service-order-invoice-form>
<ng-container *ngIf="invoiceNumber && !editMode else addInvoice">
    <li class="pt-2" *ngIf="invoiceNumber">
        <h5>Numer faktury: <b>{{ invoiceNumber }}</b></h5>
    </li>
    <div class="d-flex justify-content-end">
        <button mat-stroked-button color="primary" class="mx-1" (click)="changeEditMode()">
            <i class="fa-solid fa-pen-to-square"></i> Zmień nr faktury
        </button>
    </div>
</ng-container>
<ng-template #addInvoice>
    <ng-container *ngIf="editMode else addInvoiceNumber">
        <app-save-button [invalid]="data.invoiceForm.invalid" (closeForm)="changeEditMode()"
                         (save)="saveInvoiceNumber()"></app-save-button>
    </ng-container>
    <ng-template #addInvoiceNumber>
        <div class="d-flex justify-content-end">
            <button mat-stroked-button color="primary" class="mx-1" (click)="changeEditMode()"><i
                class="fa-solid fa-plus"></i> Dodaj nr faktury
            </button>
        </div>
    </ng-template>
</ng-template>
